import React from 'react';
import { useAuth } from '@contexts/AuthContext';
import Help from '@pages/common/Help';
import HelpPage from '@pages/client/components/HelpPage';

/**
 * /help este înregistrat o singură dată în router; clientul vede HelpPage, restul rolurilor — Help generic.
 */
const RoleAwareHelp: React.FC = () => {
  const { user } = useAuth();
  if (user?.role === 'client') {
    return <HelpPage />;
  }
  return <Help />;
};

export default RoleAwareHelp;
